import React from "react";
import PropTypes from "prop-types";
import Icon from "./MaterialIcon";
import Avatar from "./Avatar";
import "assets/app/chip.css";

@autobind
/**
 *
 */
export default class Chip extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string,
    ]),
    onClick: PropTypes.func,
  };

  static defaultProps = {
    className: "",
    onClick: () => { },
  };

  /**
   *
   * @return {Number}
   * @private
   */
  get _avatarIndex() {
    const children = this.props.children;

    if (Array.isArray(children)) {
      return children.findIndex((child) => child.type === Avatar);
    }

    return -1;
  }

  /**
   *
   * @return {Number}
   * @private
   */
  get _iconIndex() {
    const children = this.props.children;

    if (Array.isArray(children)) {
      return children.findIndex((child) => child.type === Icon);
    }

    return -1;
  }

  /**
   *
   * @param {Number} [avatar=-1]
   * @param {Number} [icon=-1]
   * @return {Element}
   * @private
   */
  _content(avatar = -1, icon = -1) {
    const children = this.props.children;

    if (Array.isArray(children)) {
      const _children = app._.cloneDeep(children);

      [icon, avatar].sort()
        .reverse()
        .forEach((index) => index > -1 && _children.splice(index, 1));

      return _children;
    }

    return children;
  }

  /**
   *
   * @return {XML}
   */
  render() {
    const { className, children, onClick, ...rest } = this.props;

    const _avatar = this._avatarIndex;
    const _icon = this._iconIndex;

    return (
      <div
        className={`chip ${className}`}
        onClick={onClick}
        {...rest}
      >

        {children[_avatar]}

        <span className="content">
          {this._content(_avatar, _icon)}
        </span>

        {children[_icon]}

      </div>
    );
  }
}
